import { render } from "./Create75Liquidation3.vue?vue&type=template&id=34f61044"
import script from "./Create75Liquidation3.vue?vue&type=script&lang=js"
export * from "./Create75Liquidation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__